<template>

	<el-dialog title="系統提示" :visible.sync="dialog" class="user-layout-dialog" :close-on-click-modal="false">
		<span>您選擇的是免費試玩通道，是供玩家用來體驗遊戲。<br>此通道為試玩帳號，所有輸贏不計入到您的個人帳戶，請悉知！</span>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="tryGame" class="tryGameBtn" :loading="loading">進 入 遊 戲</el-button>
		</span>
	</el-dialog>

</template>

<script>

import { mapGetters } from 'vuex'

export default {
	name: 'SlotGameUtilComponent',
	data () {
		return {
			dialog:false,
			stash:{},
			loading:false
		}
	},
	components :{

	},
	methods: {

		startGame(soruce, id) {


			const loading = this.$loading({
				lock: false,
				text: '遊戲啟動中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			this.$axios({
				method : 'GET',
				url : this.config.ApiUrl + '/api/' + soruce + '/start-game/' + id ,
				data: {
				},
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				loading.close();
				//console.log(response);
				if (!response.data.status) {
					return this.$layer.msg(response.data.message);
				}
				else {
					window.open(response.data.data.url,'', 'height=768,width=1024,location=no,menubar=no,menubar=no');
				}
			}).catch(error => {
				loading.close();
				console.log(error);
			});
		},
		tryGame() {
			this.loading = true;
			this.$axios({
				method : 'GET',
				url : this.config.ApiUrl + '/api/' + this.stash.soruce + '/try-game/' + this.stash.id ,
				data: {
				},
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				this.loading = false;

				if (!response.data.status) {
					return this.$layer.msg(response.data.message);
				}
				else {
					this.dialog = false;

					window.open(response.data.data.url,'', 'height=768,width=1024,location=no,menubar=no,menubar=no');
				}

			}).catch(error => {
				console.log(error);
				this.loading = false;
				this.dialog = false;
			});
		}

	},
	watch: {
	},
    computed: {
		...mapGetters({
			config: 'config',
			//user: 'user',
			//web: 'web',
		}),
		/*
		gameLists(){
			let listCount = 0;
			return this.web.tcg.filter(post => {
				var result = post.game_name.toLowerCase().includes(this.keyword.toLowerCase());
				if (!result) {
					listCount++;
					this.noRecord = (listCount == this.web.tcg.length)
				}
				return result;
			})
		},*/
    },
	created() {

		//this.$store.dispatch('getSlotLists','tcg');
	}
}
</script>

<style>
.tryGameBtn {
	font-size:15px;
	padding:10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/SlotGameUtil.vue